import { Component, OnInit } from '@angular/core';
import { ComponentSubHtmlBase } from '../component-sub-html-base/component-sub-html-base.component';

@Component({
  selector: 'app-component-sub-html-inner-template',
  templateUrl: './component-sub-html-inner-template.component.html',
  styleUrls: ['./component-sub-html-inner-template.component.scss']
})
export class ComponentSubHtmlInnerTemplateComponent extends ComponentSubHtmlBase implements OnInit {
  onEditTrackedField(formControl: any) {
    formControl.enable();
  }

  onResetTrackedField(formControl: any, fieldName: "articleName" | "articleNumber" | "printingCoverage" | "hasDirectContactWithProduct") {
    if (fieldName == 'articleName') {
      formControl.setValue(this.underlyingComponent?.articleName);
    }

    if (fieldName == 'articleNumber') {
      formControl.setValue(this.underlyingComponent?.articleNumber);
    }

    if (fieldName == 'printingCoverage') {
      const printingCoverage = this.underlyingComponent?.printingCoverage ? this.underlyingComponent.printingCoverage * 100 : this.underlyingComponent?.printingCoverage;
      formControl.setValue(printingCoverage);
    }

    if (fieldName == 'hasDirectContactWithProduct') {
      formControl.setValue(this.underlyingComponent?.hasDirectContactWithProduct);
    }

    formControl.disable();
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.form.controls.hasInternalTracking.value) {
      const componentId: number = this.form.controls.id.value;
      this.componentApiService.getPackagingComponentById(componentId).subscribe(underlyingComponent => {
        this.underlyingComponent = underlyingComponent;

        if (this.form.controls.articleName.value != underlyingComponent.articleName) {
          this.form.controls.articleName.enable();
        }

        if (this.form.controls.articleNumber.value != underlyingComponent.articleNumber) {
          this.form.controls.articleNumber.enable();
        }
        const printingCoverage = underlyingComponent?.printingCoverage ? underlyingComponent.printingCoverage * 100 : underlyingComponent?.printingCoverage;
        if (this.form.controls.printingCoverage.value != printingCoverage) {
          this.form.controls.printingCoverage.enable();
        }

        if (this.form.controls.hasDirectContactWithProduct.value != underlyingComponent.hasDirectContactWithProduct) {
          this.form.controls.hasDirectContactWithProduct.enable();
        }
      });
    }
  }
}
